export const getComparatorHeading = (assets: string[]) =>
  assets.length === 2 ? `Comparar ${assets[0]} e ${assets[1]}` : 'Comparador de FIIs';

export const shouldRenderComparatorHeading = ({ embedded, showHeading }: { embedded: boolean; showHeading: boolean }) =>
  showHeading && !embedded;
